import { useMediaQuery } from "@mui/material";
import { MidiaTextBanner as MidiaTextBannerProps } from "../../../interfaces/MidiaTextBanner";
import DefaultButton from "../../buttons/default-button";
import DefaultText from "../../typography/default-text";
import styles from "./styles.module.css";

const MidiaTextBanner: React.FC<MidiaTextBannerProps> = ({ headingRegular, headingBold, description, buttonText, image, onButtonClick, applyNegativeMargin }) => {

  const isMobile = useMediaQuery("(max-width: 899px)");

  const imageClassName = applyNegativeMargin 
    ? `${styles["midia-text-banner-image"]} ${styles["midia-text-banner-image-negative-margin"]}`
    : styles["midia-text-banner-image"];

  return (
    <div className={styles["midia-text-banner-container"]}>
      <div className={styles["midia-text-banner-content"]}>
        <div>
          {headingRegular &&
            <DefaultText color="var(--primary-blue)" size={"medium"} sx={{ fontFamily: "Montserrat-Regular" }}>
              {headingRegular}
            </DefaultText>
          }
          {headingBold &&
            <DefaultText color="var(--primary-blue)" lineHeight={isMobile ? "32px" : "48px"} size={"medium"} sx={{ fontFamily: "Montserrat-Bold" }}>
              <i>{headingBold}</i>
            </DefaultText>
          }
        </div>
        {description &&
          <DefaultText color="var(--primary-blue)" size={"small"} sx={{ fontFamily: "Montserrat-Regular" }}>
            {description}
          </DefaultText>
        }
        {buttonText &&
          <DefaultButton onClick={onButtonClick}>{buttonText}</DefaultButton>
        }
      </div>
      <img src={image} alt={"Imagem de conteúdo"} className={imageClassName} />
    </div>
  );
};

export default MidiaTextBanner;
